import { render, staticRenderFns } from "./PostLayout.vue?vue&type=template&id=89b4d2d0"
import script from "./PostLayout.vue?vue&type=script&lang=js"
export * from "./PostLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports